import { BRAND_ASSETS } from '../../lib/siteAssets';

type BrandLogoVariant = 'color' | 'white' | 'black';
type BrandLogoSize = 'sm' | 'md' | 'lg';

type BrandLogoProps = {
  variant?: BrandLogoVariant;
  size?: BrandLogoSize;
  alt?: string;
  className?: string;
};

const LOGO_SRC = {
  color: BRAND_ASSETS.colorLogo,
  white: BRAND_ASSETS.whiteLogo,
} as const;

const SIZE_CLASS: Record<BrandLogoVariant, Record<BrandLogoSize, string>> = {
  color: {
    sm: 'h-9',
    md: 'h-10',
    lg: 'h-10',
  },
  white: {
    sm: 'h-[46px]',
    md: 'h-[52px]',
    lg: 'h-[52px]',
  },
  black: {
    sm: 'h-[46px]',
    md: 'h-[52px]',
    lg: 'h-[52px]',
  },
};

export default function BrandLogo({
  variant = 'color',
  size = 'md',
  alt = 'Zobu Consulting',
  className = '',
}: BrandLogoProps) {
  const src = variant === 'white' ? LOGO_SRC.white : LOGO_SRC.color;
  const blackLogoStyle =
    variant === 'black'
      ? {
          filter: 'brightness(0) saturate(100%)',
        }
      : undefined;

  return (
    <img
      src={src}
      alt={alt}
      className={`${SIZE_CLASS[variant][size]} w-auto object-contain ${className}`.trim()}
      style={blackLogoStyle}
    />
  );
}
